import { sanitizeDocumentForFirestore } from '@/utils/firestore-sanitizer';

import { createAndStoreProjectWriteIntent } from './project-write-operation-factory';
import type { ProjectScope } from './project-scope';
import type { ProjectWriteOperation } from './write-operation';

type ArtifactFinalizationInput = {
    scope: ProjectScope;
    actorId: string;
    feature: ProjectWriteOperation['feature'];
    capability: string;
    conflictUnit: string;
    artifactType: string;
    entityId: string;
    storagePath: string;
    contentType?: string;
    metadata?: Record<string, unknown>;
};

type ArtifactRetirementInput = Omit<ArtifactFinalizationInput, 'contentType'>;

export async function enqueueArtifactFinalization(
    input: ArtifactFinalizationInput
): Promise<ProjectWriteOperation> {
    return createAndStoreProjectWriteIntent({
        scope: input.scope,
        actorId: input.actorId,
        feature: input.feature,
        capability: input.capability,
        kind: 'replaceArtifact',
        conflictUnit: input.conflictUnit,
        payload: sanitizeDocumentForFirestore({
            artifactType: input.artifactType,
            entityId: input.entityId,
            storagePath: input.storagePath,
            contentType: input.contentType,
            ...input.metadata,
        }),
    });
}

export async function enqueueArtifactRetirement(
    input: ArtifactRetirementInput
): Promise<ProjectWriteOperation> {
    return createAndStoreProjectWriteIntent({
        scope: input.scope,
        actorId: input.actorId,
        feature: input.feature,
        capability: input.capability,
        kind: 'deleteArtifact',
        conflictUnit: input.conflictUnit,
        payload: sanitizeDocumentForFirestore({
            artifactType: input.artifactType,
            entityId: input.entityId,
            storagePath: input.storagePath,
            ...input.metadata,
        }),
    });
}
